import { render, staticRenderFns } from "./IconDataManagement.vue?vue&type=template&id=0cf6f735&"
import script from "./IconDataManagement.vue?vue&type=script&lang=js&"
export * from "./IconDataManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports